document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll<HTMLElement>('[data-rlt-band-track]').forEach((track) => {
    const speed = Number(track.dataset.speed ?? 30);
    let t = 0;
    let paused = false;

    track.addEventListener('mouseenter', () => { paused = true; });   // pause on hover
    track.addEventListener('mouseleave', () => { paused = false; });  // resume on leave

    const loop = () => {
      if (!paused && !reduceMotion) {
        t = (t + 1) % 100000;
        track.style.transform = `translateX(-${t / speed}px)`;
      }
      requestAnimationFrame(loop); // animation cadencée par le navigateur
    };
    requestAnimationFrame(loop);
  });
});
